import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useInfoStore } from '../../../store/userInfo';
import { useOrderStore } from '../../../store/order';
import { Box, ButtonBase, Grid, IconButton, List, ListItem, Modal, Stack, Typography } from '@mui/material';
import { isBrowser } from 'react-device-detect';
import { createCall, getCallItems } from '../../../services/order.service';
// import close_w from '../../../assets/images/close_w.svg';
// import minus from '../../../assets/images/minus.svg';
// import plus from '../../../assets/images/add.svg';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { logger } from '../../../utils/logger';
import { useWindowDimensions } from '../../../App';

const LazyPicture = styled(LazyLoadImage)`
  object-fit: cover;
  width: ${({ width }) => (width ? `${width}rem` : "100%")};
  height: ${({ width }) => (width ? `${width}rem` : "100%")};

  &.lazy-load-image-background.opacity {
    background-image: none !important;
    opacity: 0;
    transition: opacity 0.3s;
  }

  &.lazy-load-image-background.opacity.lazy-load-image-loaded {
    opacity: 1;
  }
`;

const ServerCall: React.FC = () => {
	const {userInfo, tableInfo, currentLng} = useInfoStore();
	const { openServerCall, setOpenServerCall, setShowSnackbar, setSnackMode } = useOrderStore();
  const storeId = userInfo?.storeId;
  const { orientation } = useWindowDimensions()
  const {t} =  useTranslation(`${storeId}`)
  const [callList, setCallList] = useState<any[]>([])
  const [selectCall, setSelectCall] = useState<Array<{name: string, id: number, count: number}>>([]);
  const [requesting, setRequesting] = useState(false)
  const landMode = (orientation === "landscape") ?true: false

  useEffect(() => {
    if (!storeId) return;
    getCallItems(storeId).then(
              (res: { status: number; data: any; }) => {
		    if(res.status === 200 || res.status === 201) {
          setCallList(res.data)
        }
      },
      (error: any) => {
        logger.error("error",error)
      }
    )

  }, []);

  const hideDialog = () => {
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    setOpenServerCall(false)
  }

  const selectColor = (item: { id: any; }): any => {
		const findIndex = selectCall.findIndex(element => { return _.isEqual(element.id, item.id)});
		return (findIndex !== -1) ? true : false;
	}

  const handleSelectCall = (item: {callItemName: string, id: number}):void => {
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    if(selectCall.length === 0) {
      setSelectCall(old => [...old, {name: item.callItemName, id: item.id, count : 1}]);
      return;
    }
    const findIndex = selectCall.findIndex(element => { return _.isEqual(element.id, item.id)})
    // console.log(findIndex, selectService)
    if(findIndex === -1) {
      setSelectCall(old => [...old, {name: item.callItemName, id: item.id, count : 1}]);
    } else {
      const temp = selectCall.filter((e, i) => i !== findIndex)
      setSelectCall(temp);
    }
  }

  const handleSubCount = (item: { id: any; name: string; count: number; }): void => {
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
		const findIndex = selectCall.findIndex(element => { return _.isEqual(element.id, item.id)});
		if(findIndex !== -1) {
			if(item.count <= 1) return
			  const copySelect = selectCall
				copySelect[findIndex] = {...copySelect[findIndex], count : parseInt(item.count.toString()) - 1}
        logger.debug(copySelect)
				setSelectCall([...copySelect]);
				// console.log(selectService)
		}
  }
  const handleAddCount = (item: { id: any; name: string; count: number; }): void => {
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
		const findIndex = selectCall.findIndex(element => { return _.isEqual(element.id, item.id)});
		logger.debug(findIndex, selectCall)
		if(findIndex !== -1) {
      const copySelect = selectCall
			copySelect[findIndex] = {...copySelect[findIndex], count : parseInt(item.count.toString()) + 1}
      logger.debug(copySelect)
			setSelectCall([...copySelect]);
			// console.log(selectService)
		}
  }

  const handleRequestItems = async () => {
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    if(selectCall.length === 0) {
      toast.error('Please check Call Items')
			return;
		}
    if(requesting) return 
    setRequesting(true)
		const tableId = tableInfo.id
		const callDetails: Array<{ callItemId: number; quantity: number }> = [];
		selectCall.forEach(item => {
      const callItemId = item.id;
      const quantity = item.count;
      callDetails.push({ callItemId, quantity });
    });
		// console.log('callserver', callDetails)

		await createCall(tableId.toString(), callDetails as any)
		.then((res: { status: number; }) => {
			// console.log(res)
      setRequesting(false)
			if(res.status === 200 || res.status === 201) {
        setSnackMode(4)
        setShowSnackbar(true)
        setOpenServerCall(false);
			}
		},
		(error: any) => {
			logger.error("error",error)
      setRequesting(false)
      setOpenServerCall(false);

		})
  }

  return (
    <>
			<Modal
				keepMounted
				disableScrollLock
				disableEnforceFocus
				hideBackdrop
				open={openServerCall}
				onClose={hideDialog}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				sx={{ //You can copy the code below in your theme
					background: 'rgba(0,0,0,0.5)',
					'& .MuiBackdrop-root': {
						backgroundColor: 'transparent' // Try to remove this to see the result
					}
				}}
			>
				<Box sx={modal}>
					<Box sx={{ height: '11.2rem', padding: '2rem', flexDirection: 'column', alignItems: 'flex-start', gap: '1rem', backgroundColor: '#f00', borderRadius: '1.5rem 1.5rem 0rem 0rem'}}>
						<Typography sx={{textAlign: 'center', fontSize: '3rem', fontStyle: 'normal', fontWeight: '900', lineHeight: '150%', letterSpacing: '.15rem', color: '#fff'}}>Server Call</Typography>
						<Typography sx={{textAlign: 'center', fontSize: '1.8rem', fontStyle: 'normal', fontWeight: '500', lineHeight: '150%', color: '#fff', textWrap: 'nowrap',}}>Select the desired items and Click the request button.</Typography>
					</Box>
          <div className="touch-area" style={{position: 'absolute',right: '3rem',top: '1.4rem',}}  onClick={hideDialog}>
            <IconButton
              aria-label="close"
            >
              <LazyPicture sx={{width: '3rem', height: '3rem'}}
                src={process.env.PUBLIC_URL+'/assets/images/close_w.svg'}
                alt="close"
              />
            </IconButton>
          </div>
					<Box sx={styles.modalContent}>
						<Box sx={{gap: '6.3rem', width: '100%', height: '100%', display: 'flex', flexDirection: landMode? 'row':'column', justifyContent: 'center', alignItems: 'center'}}>
              <Box sx={{width: '50rem', height: '46.9rem'}}>
                <Box>
                  <Typography sx={{textAlign: 'center', mb: '1.1rem', fontSize: '2.4rem', fontWeight: '600', fontStyle: 'normal', lineHeight: '140%'}}>Request List</Typography>
                  <Stack sx={{display: 'flex', width: '50rem', height: '43rem', padding: '2.8rem 2rem', justifyContent: 'flex-start', alignItems: 'center', gap: '2rem', borderRadius: '1.5rem', border: '2px dashed #c9c9c9', background: '#f7f7f7'}}>
                    <Typography sx={{fontSize: '2rem', fontStyle: 'normal', fontWeight: '500', lineHeight: '140%'}}>Please select your request.</Typography>
                    <List sx={{width: '43.9rem', maxHeight: '33.2rem', display: "flex", flexFlow: "row wrap", gap: "1.6rem .8rem", flexDirection: 'row', overflow: "overlay", overflowX: 'hidden',
                        justifyContent: 'start', p: 0}}>
                      {callList.map((item, index: number) => {
                        return (
                          <ListItem key={index} sx={[{width: '20.8rem', height: '5.6rem', padding: '.8rem', justifyContent: 'center', alignItems: 'center', border: '1.5px solid #000',
                           borderRadius: '.5rem'}, selectColor(item)? {background:'#000'}: {background: '#fff'}]} onClick={() => handleSelectCall(item)}>
                            <Typography sx={[{fontSize: '2rem', fontStyle: 'normal', fontWeight: '500', lineHeight: '140%', textAlign: 'center'}, selectColor(item)? {color:'#fff'}: {color: '#000'}]} >{t(`${storeId}:callItemNames.${item.id}.${currentLng}`)}</Typography>
                          </ListItem>
                        )
                      })}
                    </List>
                  </Stack>
                </Box>
              </Box>
              <Box sx={{width: '50rem', height: '46.9rem'}}>
                <Box>
                  <Typography sx={{textAlign: 'center', mb: '1.1rem', fontSize: '2.4rem', fontWeight: '600', fontStyle: 'normal', lineHeight: '140%'}}>Selected Request List</Typography>
                  <Stack sx={{display: 'flex', width: '50rem', height: '43rem', padding: '2.8rem 2rem', justifyContent: 'flex-start', alignItems: 'center', gap: '2rem', borderRadius: '1.5rem', border: '2px solid #c9c9c9', background: '#fff'}}>
                    <Typography sx={{fontSize: '2rem', fontStyle: 'normal', fontWeight: '500', lineHeight: '140%', textWrap: 'nowrap',}}>Please confirm the quantity of requests.</Typography>
                    <List sx={{width: '43.9rem', maxHeight: '33.2rem', display: "flex", flexFlow: "column wrap", gap: "1.6rem", flexDirection: 'row', overflow: "overlay", overflowX: 'hidden',
                        justifyContent: 'center', alignItems: 'start', p: 0}}>
                      {selectCall.map((item, index: number) => {
                        return (
                          <ListItem key={index} sx={[{width: '43.9rem', p: 0}]}>
                            <Box sx={{display: 'flex', flexDirection: 'row', gap: '5.9rem',  alignItems: 'center', justifyContent: 'center', overflow: 'hidden'}}>
                              <Box sx={{width: '20.8rem', padding: '1rem 1.4rem', borderRadius: '1rem', background:'#000', justifyContent: 'center', alignItems: 'center'}}>
                                <Typography sx={{ fontSize: '2.0rem', fontStyle: 'normal', fontWeight: '500', lineHeight: '140%', textAlign: 'center', color: '#fff',
                                }} > {t(`${storeId}:callItemNames.${item.id}.${currentLng}`)}</Typography>
                              </Box>
                              <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '17.0rem', height: '4.6rem',
                                padding: '0rem 1.5rem', borderRadius: '3.0rem', backgroundColor: '#fff', border: '2px solid #E9E9E9', gap: '1rem'}}>
                                <IconButton sx={{p : '0rem'}}
                                  aria-label="minus"
                                  onClick={() => handleSubCount(item)}
                                >
                                  <img style={{background: '#fff', width: '2.6rem', height: '2.6rem'}}
                                    src={process.env.PUBLIC_URL+'/assets/images/minus.svg'}
                                    alt="minus"
                                  />
                                </IconButton>
                                <Typography id="item-price" sx={{fontSize: '2.2rem', fontWeight: '700', fontStyle: 'normal', width: '5.0rem', lineHeight: 'normal', textAlign: 'center'}}>
                                  {item.count}
                                </Typography>
                                <IconButton  sx={{p : '0rem'}}
                                  aria-label="plus"
                                  onClick={() => handleAddCount(item)}
                                >
                                  <img style={{background: '#fff', width: '2.6rem', height: '2.6rem'}}
                                    src={process.env.PUBLIC_URL+'/assets/images/add.svg'}
                                    alt="add"
                                  />
                                </IconButton>
                              </Box>
                            </Box>
                          </ListItem>
                        )
                      })}
                    </List>
                  </Stack>
                </Box>
              </Box>
            </Box>

            <ButtonBase onClick={() => handleRequestItems()} sx={{width: 'auto', flex: '0 0 auto', flexWrap: 'nowrap', height: '5.0rem', padding: '.4rem 3.3rem', background: '#F72E13', borderRadius: '3.0rem', alignSelf: 'center', mt: '2.5rem'}}>
              <Typography sx={{fontSize: '2.6rem', fontStyle: 'normal', fontWeight: '600', lineHeight: '150%', color:'#fff', textAlign: 'center', textTransform: 'none'}} >Request Items</Typography>
            </ButtonBase>
					</Box>
				</Box>
			</Modal>
      {/* <Portal>
          <SnackDialog option={mode} showSnack={showSnack} setShowSnack={setShowSnack} closeDialog={closeDialog}/>
      </Portal> */}
    </>
  );
}
const modal = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  flex: 1,
  maxHeight: '100%',
  bgcolor: 'background.paper',
  // border: '2rem solid #fff',
	borderRadius: '1.5rem',
  boxShadow: '0rem 0rem 50rem 0rem rgba(0, 0, 0, 0.40)'

};
const styles = {
  modalContent: {
    display: 'flex',
		padding: '2.5rem 3rem',
		flexDirection: 'column',
		alignItems: 'flex-start',
    justifyContent: 'center',
    height: '100%',
  },
  modalHeader: {
    position: 'absolute',
    top: 0,
    right: '1rem',
    justifyContent: 'center',
    alignItems: 'center'
  },
  /* The header takes up all the vertical space not used by the close button. */
  modalHeaderContent: {
    flexGrow: 1,
  },
  close: {
    // TypographyAlign: "center",
    position: 'absolute',
    top: '-10rem',
    right: '0rem',
    width: '4.5rem',
    height: '4.5rem'
  },
  billContainer: {
    // width: 420,
    // flex: 1,
    marginHorizontal: '2.0rem',
    flexDirection: 'row',
    justifyContent: "space-between",
    color: '#f00'
  },
  menu: {
    // flex: 1,
    // flexDirection: 'column',
    width: '36.0rem',
    height: '34.0rem',

  },
  options: {
    width: '32.0rem',
  },
  item: {
    backgroundColor: '#f9c2ff',
    padding: '2.0rem',
    marginVertical: '.8rem',
  },
  header: {
    fontSize: '3.2rem',
    backgroundColor: '#fff',
  },
  // title: {
  //   fontSize: 24,
  // },
  image: {
    flex: 1,
    width: undefined,
    height: undefined,
    minHeight: '20.0rem',
    borderRadius: '1.0rem',
    // resizeMode: 'fit',
    // transform: [{scale: 0.6}]
  },
  title: {
    marginTop: '.5rem',
    fontSize: '3.2rem',
    fontWeight: '700'
  },
  desc: {
    margin: '.5rem',
    paddingBottom: '3.0rem',
    color: '#000',
    fontSize: '1.3rem',
  },
  orderContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    margin: '1.0rem',
    marginTop: '2.0rem',
    right: '0rem',
    bottom: '-3.0rem',
  },
  counter: {
    marginTop: '.5rem',
    marginRight: '.5rem',
    right: '0rem',
    width: '15.0rem',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  listItem: {
    // TypographyAlign: 'center',
    // TypographyAlignVertical: 'center',
    fontSize: '1.5rem',
    marginHorizontal: '1.2rem' 
  },
  order: {
    backgroundColor: '#F00',
    color: '#fff',
    TypographyAlign: 'center',
    borderRadius: '1.5rem',
    fontSize: '2.8rem',
    fontWeight: 'bold',
    padding: '.5rem',
    width: '42.0rem',
  },
  menuName: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-evenly'
    // justifyContent: 'space-between',
    // margin: 5,
  },
  optionName: {
    // flex: 2,
    marginTop: '1.0rem',
    marginLeft: '15.0rem',
    marginRight: '5.0rem',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  optionTypography: {
    TypographyAlignVertical: 'center',
    color: '#000',
    fontSize: '1.9rem',
  },
  menuTypography: {
    fontSize: '2.3rem',
    fontWeight: 'bold'
  }
}

export default ServerCall;
